const ERROR = 'error';
const INFO = 'info';
const SUCCESS = 'success';
const SYSTEM = 'system';
const WARNING = 'warning';
export const ALERT_BANNER_ERROR_TYPE = ERROR;
export const ALERT_BANNER_INFO_TYPE = INFO;
export const ALERT_BANNER_SUCCESS_TYPE = SUCCESS;
export const ALERT_BANNER_WARNING_TYPE = WARNING;
export const ALERT_BANNER_SUPPORTED_TYPES = [
  ALERT_BANNER_ERROR_TYPE,
  ALERT_BANNER_INFO_TYPE,
  ALERT_BANNER_SUCCESS_TYPE,
  ALERT_BANNER_WARNING_TYPE,
];
export const TOAST_ERROR_TYPE = ERROR;
export const TOAST_EXIT_ANIMATION_MS = 300;
export const TOAST_ICONS = {
  [ERROR]: 'triangle-exclamation-mark',
  [SUCCESS]: 'circle-check',
  [SYSTEM]: 'circle-i',
};
export const TOAST_SUCCESS_TYPE = SUCCESS;
export const TOAST_SYSTEM_TYPE = SYSTEM;
export const TOAST_SUPPORTED_TYPES = [TOAST_ERROR_TYPE, TOAST_SUCCESS_TYPE, TOAST_SYSTEM_TYPE];
export const TOAST_DEFAULT_CTA_TIMEOUT = 10000;
export const TOAST_DEFAULT_TIMEOUT = 3000;

export default {
  ALERT_BANNER_ERROR_TYPE,
  ALERT_BANNER_INFO_TYPE,
  ALERT_BANNER_SUCCESS_TYPE,
  ALERT_BANNER_WARNING_TYPE,
  ALERT_BANNER_SUPPORTED_TYPES,
  TOAST_DEFAULT_CTA_TIMEOUT,
  TOAST_DEFAULT_TIMEOUT,
  TOAST_ERROR_TYPE,
  TOAST_EXIT_ANIMATION_MS,
  TOAST_ICONS,
  TOAST_SUCCESS_TYPE,
  TOAST_SYSTEM_TYPE,
  TOAST_SUPPORTED_TYPES,
};
